import styled from "styled-components";

export const AddCardContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: inherit;

  width: 100%;
`;

export const FormContainer = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem;

  border-radius: 10px;
  width: 100%;

  background-color: #ffffff;

  #form-inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    width: 100%;
  }

  @media (max-width: 800px) {
    > div {
      display: none;
    }
  }
`;

export const FormField = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;

  grid-column: 1 / span 2;

  &#cvc,
  &#expiry {
    grid-column: auto;
  }
`;

export const FormFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  width: 100%;

  * {
    max-width: 12.5rem;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;
